<div
  *ngIf="
    !!subbedItem &&
    !!cartItem?.orderItem?.productNumber &&
    (this.platformService?.isTouchExperience$ | async) === false
  "
  data-cy="product-card-top-drawer-section"
  class="top-drawer"
>
  <ion-icon
    data-cy="product-card-top-drawer-icon"
    name="information-circle-outline"
  ></ion-icon>
  <p data-cy="product-card-top-drawer-text">
    <span data-cy="product-card-top-drawer-subtext-1">
      {{ 'i18n.orderPage.autoSubWithProduct' | translate }}
      {{ cartItem.orderItem.productNumber }}.
      {{ 'i18n.orderPage.autoSubAvailability' | translate }}
    </span>
  </p>
</div>

<ion-card class="usf-card-content" [class.split-card]="!!subbedItem">
  <ng-container *ngIf="!!subbedItem">
    <div class="orig-item">
      <div class="oos-message">
        <ion-icon name="close-circle-outline"></ion-icon>
        <span class="bold">{{
          'i18n.lists.productCardMsgs.outOfStock' | translate
        }}</span
        ><ng-container>{{
          'i18n.lists.productCardMsgs.willShipIfAvail' | translate
        }}</ng-container>
      </div>
      <div class="usf-order-card-info-inner" [class.split-card]="!!subbedItem">
        <div class="usf-order-card-desc">
          <div
            *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
            class="usf-order-card-desc-body-txt"
            [attr.data-cy]="
              'confirmation-page-product-' +
              subbedItem?.productSummary?.productNumber +
              '-brand-text'
            "
          >
            {{ subbedItem?.productSummary?.brand | acronymTitleCase }}
          </div>
          <div
            *ngIf="!navigationRestricted"
            class="usf-order-card-desc-heading-txt"
            (click)="productClickHandler()"
            data-cy="confirmation-page-product-description-text"
          >
            <a
              >{{ subbedItem?.productSummary?.productDescTxtl | titlecase }}
            </a>
          </div>
          <div
            *ngIf="navigationRestricted"
            class="usf-order-card-desc-heading-txt"
            data-cy="confirmation-page-product-description-text"
          >
            <span
              >{{ subbedItem?.productSummary?.productDescTxtl | titlecase }}
            </span>
          </div>

          <div class="usf-order-card-desc-body-txt">
            <div
              class="display-price"
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-product-number-text'
              "
            >
              <span class="display-price-prodcut-number"></span>
              #{{ subbedItem?.productSummary?.productNumber }}
              <span class="border">|</span>
              {{ subbedItem?.productSummary?.salesPackSize }}
              <span class="border">|</span>
              <div
                class="desc-case-each-price"
                [attr.data-cy]="
                  'confirmation-page-product-' +
                  subbedItem?.productSummary?.productNumber +
                  '-price-text'
                "
              >
                <ng-container
                  *ngIf="
                    subbedItem?.orderItem?.unitPrice ||
                    subbedItem?.orderItem?.unitPrice === 0
                  "
                >
                  {{ subbedItem?.orderItem?.unitPrice | currency }}
                  {{ subbedItem?.orderItem?.priceUOM }}
                </ng-container>
                <ng-container
                  *ngIf="
                    subbedItem?.productSummary?.breakable &&
                    (subbedItem?.orderItem?.eachPrice ||
                      subbedItem?.orderItem?.eachPrice === 0)
                  "
                  >/ {{ subbedItem?.orderItem?.eachPrice | currency }}
                  {{
                    subbedItem?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA'
                  }}</ng-container
                >
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
          class="usf-order-card-totals"
        >
          <div class="usf-order-card-totals-inner">
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-ordered-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.ordered' | translate
              }}</span>
              {{ subbedItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
            </p>
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ subbedItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
            <ng-container
              *ngIf="
                subbedItem?.orderItem?.totalDollars ||
                subbedItem?.orderItem?.totalDollars === 0
              "
            >
              <p
                *ngIf="
                  subbedItem?.orderItem?.totalDollars ||
                  subbedItem?.orderItem?.totalDollars === 0
                "
                [attr.data-cy]="
                  'confirmation-page-product-' +
                  subbedItem?.productSummary?.productNumber +
                  '-line-total-text'
                "
              >
                <span class="usf-order-card-totals-inner-title"
                  >Line Total:</span
                >
                {{ subbedItem?.orderItem?.totalDollars | currency }}
              </p>
            </ng-container>
          </div>
        </div>

        <div
          class="usf-order-card-totals-mobile"
          *ngIf="this.platformService?.isTouchExperience$ | async"
        >
          <div class="usf-order-card-totals-inner-mobile">
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-ordered-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.ordered' | translate
              }}</span>
              {{ subbedItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
            </p>

            <p
              *ngIf="
                subbedItem?.orderItem?.totalDollars ||
                subbedItem?.orderItem?.totalDollars === 0
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-line-total-text'
              "
              class="mobile-line-total-text"
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.lineTotal' | translate
              }}</span>
              <span>
                {{ subbedItem?.orderItem?.totalDollars | currency }}
              </span>
            </p>
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title"
                >{{ 'i18n.confirmationPage.reserved' | translate }}
              </span>
              {{ subbedItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
          </div>

          <div class="usf-order-card-totals-inner-tablet">
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-ordered-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.ordered' | translate
              }}</span>
              {{ subbedItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
            </p>

            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ subbedItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ subbedItem?.orderItem?.eachesReserved || 0 }} EA
            </p>

            <p
              *ngIf="
                subbedItem?.orderItem?.totalDollars ||
                subbedItem?.orderItem?.totalDollars === 0
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                subbedItem?.productSummary?.productNumber +
                '-line-total-text'
              "
              class="line-total"
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.lineTotal' | translate
              }}</span>
              {{ subbedItem?.orderItem?.totalDollars | currency }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="usf-order-card-info-product-tags"
        *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
      >
        <div
          class="product-tag-wrap"
          [attr.data-cy]="
            'confirmation-page-product-' +
            cartItem?.productState?.productNumber +
            '-display-tags'
          "
        >
          <app-usf-product-tag-list
            *ngIf="displayTags?.length > 0"
            [tagList]="displayTags?.slice(0, this.maxDisplayTags)"
          >
          </app-usf-product-tag-list>
        </div>
        <p
          class="product-tag-extra"
          *ngIf="displayTags?.length > this.maxDisplayTags"
          [attr.data-cy]="
            'confirmation-page-product-' +
            cartItem?.productState?.productNumber +
            '-max-display-tags'
          "
        >
          {{ '+' + (displayTags?.length - this.maxDisplayTags) }}
        </p>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="
      !!subbedItem &&
      !!cartItem?.orderItem?.productNumber &&
      (this.platformService?.isTouchExperience$ | async)
    "
    data-cy="product-card-top-drawer-section"
    class="top-drawer"
  >
    <ion-icon
      data-cy="product-card-top-drawer-icon"
      name="information-circle-outline"
    ></ion-icon>
    <span data-cy="product-card-top-drawer-subtext-1"
      >{{ 'i18n.orderPage.autoSubWithProduct' | translate }}
      {{ cartItem.orderItem.productNumber }}.
      {{ 'i18n.orderPage.autoSubAvailability' | translate }}
    </span>
  </div>
  <div class="subbed-item" [class.split-card]="!!subbedItem">
    <div class="auto-sub-product" *ngIf="!!subbedItem">
      <ion-icon name="sync-outline"></ion-icon>
      <span>{{ 'i18n.orderPage.autoSubProduct' | translate }}</span>
    </div>
    <div class="usf-order-card-info-inner" [class.split-card]="!!subbedItem">
      <div class="usf-order-card-img">
        <img
          src="{{ thumbnailImageURL }}"
          (error)="
            this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
          "
          *ngIf="!!thumbnailImageURL"
          (click)="navigationRestricted ? undefined : productClickHandler()"
          [attr.data-cy]="
            'confirmation-page-product-' +
            subbedItem?.productSummary?.productNumber +
            '-image'
          "
        />
        <ion-icon
          name="restaurant"
          (click)="navigationRestricted ? undefined : productClickHandler()"
          [attr.data-cy]="
            'confirmation-page-product-' +
            subbedItem?.productSummary?.productNumber +
            '-icon'
          "
          *ngIf="!thumbnailImageURL"
          class="no-image"
        ></ion-icon>
      </div>
      <div class="usf-order-card-desc">
        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
          class="usf-order-card-desc-body-txt"
          [attr.data-cy]="
            'confirmation-page-product-' +
            cartItem?.productState?.productNumber +
            '-brand-text'
          "
        >
          {{ cartItem?.productState?.brand | acronymTitleCase }}
        </div>

        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
          class="usf-order-card-desc-body-txt-tablet"
          [attr.data-cy]="
            'confirmation-page-product-' +
            cartItem?.productState?.productNumber +
            '-brand-text'
          "
        >
          {{ cartItem?.productState?.brand | acronymTitleCase }}
        </div>

        <div
          class="usf-order-card-desc-body-txt-mobile"
          [attr.data-cy]="
            'confirmation-page-product-' +
            cartItem?.productState?.productNumber +
            '-number-text'
          "
          *ngIf="this.platformService?.isTouchExperience$ | async"
        >
          {{ cartItem?.productState?.brand | acronymTitleCase }}
          <span class="border">|</span>
          #{{ cartItem?.productState?.productNumber }}
        </div>

        <div
          *ngIf="!navigationRestricted"
          class="usf-order-card-desc-heading-txt"
          (click)="productClickHandler()"
          data-cy="confirmation-page-product-description-text"
        >
          <a>{{ cartItem?.productState?.productDescTxtl | titlecase }} </a>
        </div>

        <div
          *ngIf="navigationRestricted"
          class="usf-order-card-desc-heading-txt"
          data-cy="confirmation-page-product-description-text"
        >
          <span
            >{{ cartItem?.productState?.productDescTxtl | titlecase }}
          </span>
        </div>

        <!-- mobile-->
        <div
          class="usf-order-card-desc-body-txt-mobile"
          *ngIf="this.platformService.isTouchExperience$ | async"
        >
          <div
            class="display-price"
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-product-number-text'
            "
          >
            {{ cartItem?.productState?.salesPackSize }}
            <span class="border">|</span>
            <div
              class="desc-case-each-price"
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-price-text'
              "
            >
              <ng-container
                *ngIf="
                  cartItem?.orderItem?.unitPrice ||
                  cartItem?.orderItem?.unitPrice === 0
                "
              >
                {{ cartItem?.orderItem?.unitPrice | currency }}
                {{ cartItem?.orderItem?.priceUOM }}
              </ng-container>
              <ng-container
                *ngIf="
                  cartItem?.productState?.breakable &&
                  (cartItem?.orderItem?.eachPrice ||
                    cartItem?.orderItem?.eachPrice === 0)
                "
                >/ {{ cartItem?.orderItem?.eachPrice | currency }}
                {{
                  cartItem?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA'
                }}</ng-container
              >
            </div>
          </div>
        </div>

        <!--tablet-->
        <div
          class="usf-order-card-desc-body-txt"
          [class.usf-order-card-desc-body-txt-tablet]="
            this.platformService.isTouchExperience$ | async
          "
        >
          <div
            class="display-price"
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-product-number-text'
            "
          >
            <span class="display-price-prodcut-number"
              >#{{ cartItem?.productState?.productNumber }}</span
            >
            <span class="border display-price-prodcut-number">|</span>
            {{ cartItem?.productState?.salesPackSize }}
            <span class="border">|</span>
            <div
              class="desc-case-each-price"
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-price-text'
              "
            >
              <ng-container
                *ngIf="
                  cartItem?.orderItem?.unitPrice ||
                  cartItem?.orderItem?.unitPrice === 0
                "
              >
                {{ cartItem?.orderItem?.unitPrice | currency }}
                {{ cartItem?.orderItem?.priceUOM }}
              </ng-container>
              <ng-container
                *ngIf="
                  cartItem?.productState?.breakable &&
                  (cartItem?.orderItem?.eachPrice ||
                    cartItem?.orderItem?.eachPrice === 0)
                "
                >/ {{ cartItem?.orderItem?.eachPrice | currency }}
                {{
                  cartItem?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA'
                }}</ng-container
              >
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
        class="usf-order-card-totals"
      >
        <div class="usf-order-card-totals-inner">
          <p
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.ordered' | translate
            }}</span>
            {{ cartItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
            {{ cartItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
          </p>
          <p
            *appHideSplit="[atpFeatureFlag]"
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-reserved-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.reserved' | translate
            }}</span>
            {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
            {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
          </p>
          <ng-container *appShowSplit="[atpFeatureFlag]">
            <p
              *ngIf="
                !(
                  availableToPromise &&
                  cartItem?.productState?.availableToPromise &&
                  (cartItem?.orderItem?.unitsReserved <
                    cartItem?.orderItem?.unitsOrdered?.currentValue ||
                    cartItem?.orderItem?.eachesReserved <
                      cartItem?.orderItem?.eachesOrdered?.currentValue)
                )
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
            <p
              *ngIf="
                availableToPromise &&
                cartItem?.productState?.availableToPromise &&
                (cartItem?.orderItem?.unitsReserved <
                  cartItem?.orderItem?.unitsOrdered?.currentValue ||
                  cartItem?.orderItem?.eachesReserved <
                    cartItem?.orderItem?.eachesOrdered?.currentValue)
              "
              class="atp"
              data-cy="product-card-top-drawer-text"
            >
              {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              cartItem?.orderItem?.totalDollars ||
              cartItem?.orderItem?.totalDollars === 0
            "
          >
            <p
              *ngIf="
                cartItem?.orderItem?.totalDollars ||
                cartItem?.orderItem?.totalDollars === 0
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-line-total-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.lineTotal' | translate
              }}</span>
              {{ cartItem?.orderItem?.totalDollars | currency }}
            </p>
          </ng-container>
        </div>
      </div>

      <div
        class="usf-order-card-totals-mobile"
        *ngIf="this.platformService?.isTouchExperience$ | async"
      >
        <div class="usf-order-card-totals-inner-mobile">
          <p
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.ordered' | translate
            }}</span>
            {{ cartItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
            {{ cartItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
          </p>
          <ng-container *ngIf="!!subbedItem">
            <p
              *ngIf="
                cartItem?.orderItem?.totalDollars ||
                cartItem?.orderItem?.totalDollars === 0
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-line-total-text'
              "
              [class.mobile-line-total-text]="!!subbedItem"
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.lineTotal' | translate
              }}</span>
              <span> {{ cartItem?.orderItem?.totalDollars | currency }} </span>
            </p>
            <p
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
          </ng-container>
          <ng-container *ngIf="!subbedItem">
            <p
              *ngIf="
                cartItem?.orderItem?.totalDollars ||
                cartItem?.orderItem?.totalDollars === 0
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-line-total-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.lineTotal' | translate
              }}</span>
              <span> {{ cartItem?.orderItem?.totalDollars | currency }} </span>
            </p>
            <p
              *appHideSplit="[atpFeatureFlag]"
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
            <ng-container *appShowSplit="[atpFeatureFlag]">
              <p
                *ngIf="
                  !(
                    availableToPromise &&
                    cartItem?.productState?.availableToPromise &&
                    (cartItem?.orderItem?.unitsReserved <
                      cartItem?.orderItem?.unitsOrdered?.currentValue ||
                      cartItem?.orderItem?.eachesReserved <
                        cartItem?.orderItem?.eachesOrdered?.currentValue)
                  )
                "
                [attr.data-cy]="
                  'confirmation-page-product-' +
                  cartItem?.productState?.productNumber +
                  '-reserved-text'
                "
              >
                <span class="usf-order-card-totals-inner-title">{{
                  'i18n.confirmationPage.reserved' | translate
                }}</span>
                {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
                {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
              </p>
              <p
                *ngIf="
                  availableToPromise &&
                  cartItem?.productState?.availableToPromise &&
                  (cartItem?.orderItem?.unitsReserved <
                    cartItem?.orderItem?.unitsOrdered?.currentValue ||
                    cartItem?.orderItem?.eachesReserved <
                      cartItem?.orderItem?.eachesOrdered?.currentValue)
                "
                class="atp"
                data-cy="product-card-top-drawer-text"
              >
                {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
              </p>
            </ng-container>
          </ng-container>
        </div>

        <div class="usf-order-card-totals-inner-tablet">
          <p
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.ordered' | translate
            }}</span>
            {{ cartItem?.orderItem?.unitsOrdered?.currentValue || 0 }} CS /
            {{ cartItem?.orderItem?.eachesOrdered?.currentValue || 0 }} EA
          </p>

          <p
            *appHideSplit="[atpFeatureFlag]"
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-reserved-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.reserved' | translate
            }}</span>
            {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
            {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
          </p>

          <ng-container *appShowSplit="[atpFeatureFlag]">
            <p
              *ngIf="
                !(
                  availableToPromise &&
                  cartItem?.productState?.availableToPromise &&
                  (cartItem?.orderItem?.unitsReserved <
                    cartItem?.orderItem?.unitsOrdered?.currentValue ||
                    cartItem?.orderItem?.eachesReserved <
                      cartItem?.orderItem?.eachesOrdered?.currentValue)
                )
              "
              [attr.data-cy]="
                'confirmation-page-product-' +
                cartItem?.productState?.productNumber +
                '-reserved-text'
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.confirmationPage.reserved' | translate
              }}</span>
              {{ cartItem?.orderItem?.unitsReserved || 0 }} CS /
              {{ cartItem?.orderItem?.eachesReserved || 0 }} EA
            </p>
            <p
              *ngIf="
                availableToPromise &&
                cartItem?.productState?.availableToPromise &&
                (cartItem?.orderItem?.unitsReserved <
                  cartItem?.orderItem?.unitsOrdered?.currentValue ||
                  cartItem?.orderItem?.eachesReserved <
                    cartItem?.orderItem?.eachesOrdered?.currentValue)
              "
              class="atp"
              data-cy="product-card-top-drawer-text"
            >
              {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
            </p>
          </ng-container>

          <p
            *ngIf="
              cartItem?.orderItem?.totalDollars ||
              cartItem?.orderItem?.totalDollars === 0
            "
            [attr.data-cy]="
              'confirmation-page-product-' +
              cartItem?.productState?.productNumber +
              '-line-total-text'
            "
            class="line-total"
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.confirmationPage.lineTotal' | translate
            }}</span>
            {{ cartItem?.orderItem?.totalDollars | currency }}
          </p>
        </div>
      </div>
    </div>

    <div class="usf-order-card-info-product-tags">
      <div
        class="product-tag-wrap"
        [attr.data-cy]="
          'confirmation-page-product-' +
          cartItem?.productState?.productNumber +
          '-display-tags'
        "
      >
        <app-usf-product-tag-list
          *ngIf="displayTags?.length > 0"
          [tagList]="displayTags?.slice(0, this.maxDisplayTags)"
        >
        </app-usf-product-tag-list>
      </div>
      <p
        class="product-tag-extra"
        *ngIf="displayTags?.length > this.maxDisplayTags"
        [attr.data-cy]="
          'confirmation-page-product-' +
          cartItem?.productState?.productNumber +
          '-max-display-tags'
        "
      >
        {{ '+' + (displayTags?.length - this.maxDisplayTags) }}
      </p>
    </div>
  </div>
</ion-card>
